import React from 'react'
import PdfTemplates from './PdfTemplates/PdfTemplates'
import HsnCheck from './HSNChecks/HsnCheck';
import UniqueNumber from './UniqueNumber/UniqueNumber';
import ExpensePdfTemplates from './ExpensePdfTemplate/ExpensePdfTemplates';
import MiscellaneousSetting from './MiscellaneousSetting/MiscellaneousSetting';

type AppProps={
    history?:any;
    menuName:string;
}

const GeneralSettingContentArea = ({menuName ,history}:AppProps) => {
    const renderComponent=(menuName:string)=>{
         switch (menuName) {
            case "Sales Templates": return <PdfTemplates  history={history} menuName={menuName} />
            case "Expense Templates": return <ExpensePdfTemplates history={history} menuName={menuName} />
           
            case "HSN Checks": return <HsnCheck  
                history={history} menuName={menuName}
                 />
            case "Auto Unique Number": return <UniqueNumber
                history={history} menuName={menuName}
                />
            case "Miscellaneous Settings": return <MiscellaneousSetting
                history={history} menuName={menuName}
                />
            default:
                break;
            
         }
    }
  return (
    <div style={{ flex: 5 }} className="p-3 general_setting_content_area">
    {renderComponent(menuName)} 
  </div>
  )
}

export default GeneralSettingContentArea
